import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faBuilding,
  faLocationDot,
  faPuzzlePiece,
  faRoute,
  faUserGroup,
  faUserShield
} from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import backgroundImage from '../Images/fundoteambuilding.png';
import '../CSS/Despedidas.css';

const LoretoChallengeEN = () => {
  return (
    <div className="er-partyPage">
      <section className="er-partyHero" aria-label="Loreto Challenge">
        <img src={backgroundImage} alt="" className="er-partyHeroImg" />
        <div className="er-partyHeroOverlay">
          <div className="er-partyHeroInner">
            <div className="er-partyBadge">Large groups • Riddles • Indoor</div>

            <h1 className="er-partyTitle">
              Loreto <span className="er-partyTitleAccent">Challenge</span>
            </h1>

            <p className="er-partyLead">An indoor peddypaper with riddles!</p>
            <p className="er-partyText">
              An activity designed for large groups: it works like a peddypaper, but indoors,
              with riddles and challenges that get the team exploring, communicating and solving mysteries together.
            </p>

            <div className="er-partyCtas">
              <a
                className="er-partyCtaPrimary"
                href="https://wa.me/351934403133"
                target="_blank"
                rel="noreferrer"
              >
                <FontAwesomeIcon icon={faWhatsapp} />
                Talk to us
              </a>
            </div>
          </div>

          <div className="er-partyHeroCards">
            <article className="er-partyHeroCard">
              <FontAwesomeIcon icon={faRoute} className="er-partyHeroCardIcon" />
              <h2 className="er-partyHeroCardTitle">Peddypaper style</h2>
              <p className="er-partyHeroCardText">
                A route of clues and missions — with peddypaper energy, all in an indoor space.
              </p>
            </article>
            <article className="er-partyHeroCard">
              <FontAwesomeIcon icon={faPuzzlePiece} className="er-partyHeroCardIcon" />
              <h2 className="er-partyHeroCardTitle">Riddles & puzzles</h2>
              <p className="er-partyHeroCardText">
                Challenges designed to test logic, observation and teamwork.
              </p>
            </article>
            <article className="er-partyHeroCard">
              <FontAwesomeIcon icon={faUserGroup} className="er-partyHeroCardIcon" />
              <h2 className="er-partyHeroCardTitle">Large groups</h2>
              <p className="er-partyHeroCardText">
                Ideal for classes, companies and big groups looking for a dynamic, engaging activity.
              </p>
            </article>
          </div>

          <div className="er-partyHeroCards">
            <article className="er-partyHeroCard">
              <FontAwesomeIcon icon={faBuilding} className="er-partyFeatureIcon" />
              <h3 className="er-partyHeroCardTitle">100% indoor</h3>
              <p className="er-partyFeatureText">
                Weather-proof: the whole adventure happens indoors.
              </p>
            </article>
            <article className="er-partyHeroCard">
              <FontAwesomeIcon icon={faLocationDot} className="er-partyFeatureIcon" />
              <h2 className="er-partyHeroCardTitle">Great location</h2>
              <p className="er-partyFeatureText">
                In the heart of Bragança — easy to reach and perfect for group events.
              </p>
            </article>
            <article className="er-partyHeroCard">
              <FontAwesomeIcon icon={faUserShield} className="er-partyFeatureIcon" />
              <h3 className="er-partyHeroCardTitle">Dedicated team</h3>
              <p className="er-partyFeatureText">
                Support before, during and after the activity so everything runs smoothly.
              </p>
            </article>
          </div>
        </div>
      </section>
    </div>
  );
};

export default LoretoChallengeEN;
